<template>
  <v-card color="grey lighten-3">
    <v-card-text class="pa-5">
      <v-layout row>
        <v-flex xs9 class="pr-5">
          <v-autocomplete
            v-model="promotion_stores[0]"
            :items="store_list_free"
            :loading="isLoadingStore"
            color="black"
            hide-no-data
            hide-selected
            item-text="store_name_th"
            item-value="store_id"
            label="Search store"
            :disabled="isEditPromotion"
            placeholder="Select store"
            @change="selectStore($event)"
            :rules="[v => !!v || 'Store is required']"
            v-if="form.promotion_order_type == 3"
          ></v-autocomplete>
          <v-autocomplete
            v-model="promotion_stores[0]"
            :items="store_list"
            :loading="isLoadingStore"
            color="black"
            hide-no-data
            hide-selected
            item-text="store_name_th"
            item-value="store_id"
            label="Search store"
            placeholder="Select store"
            :disabled="isEditPromotion"
            @change="selectStore($event)"
            :rules="[v => !!v || 'Store is required']"
            v-else
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-text-field
            :disabled="isEditPromotion"
            v-model.number="form.promotion_fix_price"
            :rules="[rules.required,rules.onlyNumber]"
            label="Fix product price (THB)"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs9>
          <v-layout row wrap v-for="(info,index) in promotion_product_gifts" :key="index">
            <v-flex xs2 sm2 md2 class="promo-title">
              <span class="style-title-promo">Get {{index+1}} :</span>
            </v-flex>
            <v-flex xs8 sm8 md8 class="pl-2">
              <v-autocomplete
                :disabled="isEditPromotion"
                v-model="promotion_product_gifts[index]"
                :items="product_list"
                :loading="isLoadingProduct"
                color="black"
                hide-no-data
                hide-selected
                item-text="product_name_th"
                item-value="product_id"
                label="Search product"
                placeholder="Select product"
                :rules="[v => !!v || 'Product is required']"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs2 sm2 md2 class="text-xs-center pt-4" v-if="!isEditPromotion">
              <v-icon
                medium
                color="green"
                :disabled="isLoadingProduct"
                @click="moreStore()"
                v-if="index == 0"
              >add_box</v-icon>
              <v-icon
                medium
                color="red"
                :disabled="isLoadingProduct"
                @click="lessStore(index)"
                v-else
              >indeterminate_check_box</v-icon>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs3>
          <v-text-field
            :disabled="isEditPromotion"
            v-model.number="form.promotion_gift_amount"
            :rules="[rules.required,rules.onlyNumber]"
            label="Promotion gift amount"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["promotion_product_gifts", "promotion_stores", "form"],
  data() {
    return {
      isLoadingStore: false,
      isLoadingProduct: false,

      product_list: [],
      rules: {
        required: (value) => !!value || "Required.",
        onlyNumber: (value) =>
          /^[0-9+.]*$/.test(value) || "only numbers are allowed.",
      },
    };
  },
  computed: {
    ...mapGetters({
      store_list_free: "fetchStoreBack/autocompleteStoreFreedelivery",
      store_list: "fetchStoreBack/autocompleteStore",
      isEditPromotion: "isEditPromotion",
    }),
  },
  methods: {
    moreStore() {
      this.promotion_product_gifts.push({ store: null, product: null });
    },
    lessStore(index) {
      this.promotion_product_gifts.splice(index, 1);
    },
    async fetchStore() {
      if (this.isLoadingStore) return;
      this.isLoadingStore = true;
      await this.$store.dispatch("fetchStoreBack/getStoreList");
      this.isLoadingStore = false;
    },
    selectStore(store_id) {
      this.$emit("clearPromotionProducts");
      this.fetchProduct(store_id);
    },
    async fetchProduct(store_id) {
      this.product_list = [];
      this.isLoadingProduct = true;
      let product_list_data = await this.$store.dispatch(
        "fetchOrderDetailBack/getProductByStore",
        store_id
      );
      this.product_list = product_list_data;
      this.isLoadingProduct = false;
    },
    async initialzation() {
      this.fetchStore();
      for (let key in this.promotion_stores) {
        if (this.promotion_stores[0] != null) {
          this.fetchProduct(this.promotion_stores[0]);
        }
      }
    },
  },

  created() {
    this.initialzation();
  },
};
</script>

<style>
</style>
